const sharedKeywords = [
  "California solar company",
  "Los Angeles solar installation",
  "California roofing contractor",
  "solar and roofing company Los Angeles",
  "battery storage California",
  "solar panel repair California",
  "roof replacement Los Angeles",
  "roof repair Los Angeles",
  "commercial solar contractor California",
  "residential solar company California",
  "energy efficient roofing California",
  "roof inspection Los Angeles",
  "solar quote California",
  "solar financing California",
  "Los Angeles roofing services",
];

const pageSeo = {
  "/": {
    title: "Monarch Solar & Roofing Solutions | Solar & Roofing in Los Angeles, California",
    description: "Professional solar installation, roofing services, battery storage, and quote-ready support for Los Angeles and California property owners.",
    keywords: [...sharedKeywords, "solar company Los Angeles", "roofing company Los Angeles", "California solar roofing business"],
    schemaType: "ProfessionalService",
  },
  "/solar-services": {
    title: "Solar Services California | Installation, Repair & Battery Storage",
    description: "Explore California solar services from Monarch including custom installation, solar repair, maintenance, and battery storage planning.",
    keywords: [...sharedKeywords, "solar installation California", "solar maintenance California", "battery backup California"],
    schemaType: "ProfessionalService",
  },
  "/roofing-services": {
    title: "Roofing Services Los Angeles | Repair, Replacement & Inspections",
    description: "Trusted Los Angeles roofing services including roof replacement, repairs, inspections, materials guidance, and storm damage help.",
    keywords: [...sharedKeywords, "roof replacement California", "roof leak repair Los Angeles", "storm damage roofing California"],
    schemaType: "RoofingContractor",
  },
  "/about": {
    title: "About Monarch Solar & Roofing Solutions | California Exterior Experts",
    description: "Learn about Monarch Solar & Roofing Solutions, our mission, service values, and commitment to California property owners.",
    keywords: [...sharedKeywords, "about solar company California", "about roofing contractor Los Angeles"],
    schemaType: "ProfessionalService",
  },
  "/gallery": {
    title: "Solar & Roofing Project Gallery | California Homes & Commercial Projects",
    description: "Browse Monarch project photos featuring solar installations, roof upgrades, and energy improvements across California properties.",
    keywords: [...sharedKeywords, "solar project gallery California", "roofing project photos Los Angeles"],
    schemaType: "ProfessionalService",
  },
  "/contact": {
    title: "Contact Monarch Solar & Roofing Solutions | Free Quote in Los Angeles",
    description: "Contact Monarch Solar & Roofing Solutions for solar, roofing, and battery storage quotes in Los Angeles and nearby California service areas.",
    keywords: [...sharedKeywords, "contact solar company California", "free roofing quote Los Angeles"],
    schemaType: "ProfessionalService",
  },
  "/solar-installation-california": {
    title: "Solar Installation California | Residential & Commercial Solar Systems",
    description: "Professional solar installation in California for homes and commercial buildings, designed for efficiency, savings, and long-term performance.",
    keywords: [...sharedKeywords, "solar installation company California", "residential solar installation Los Angeles", "commercial solar installation California"],
    schemaType: "ProfessionalService",
  },
  "/solar-repair-california": {
    title: "Solar Repair California | Panel Repair, Monitoring & Maintenance",
    description: "California solar repair and maintenance services for panel troubleshooting, output issues, inspections, and performance recovery.",
    keywords: [...sharedKeywords, "solar repair California", "solar panel maintenance Los Angeles", "solar troubleshooting California"],
    schemaType: "ProfessionalService",
  },
  "/battery-storage-california": {
    title: "Battery Storage California | Home Backup Power & Energy Resilience",
    description: "Battery storage solutions in California for backup power, outage protection, load shifting, and better solar energy control.",
    keywords: [...sharedKeywords, "battery storage California", "home battery backup Los Angeles", "solar battery installation California"],
    schemaType: "ProfessionalService",
  },
  "/california-service-areas": {
    title: "California Solar Service Areas | Los Angeles & Nearby Communities",
    description: "See the California communities Monarch serves for solar, roofing, battery storage, inspections, and quote-ready project support.",
    keywords: [...sharedKeywords, "California solar service areas", "Los Angeles solar company near me", "Southern California roofing company"],
    schemaType: "ProfessionalService",
  },
};

export function getSeoContent(pathname) {
  return pageSeo[pathname] || pageSeo["/"];
}

export const generatedSeoKeywords = sharedKeywords;